import css from "./ShowListingDetails.module.scss";
// import IconCollection from "../IconCollection/IconCollection";
import stageImage from "../../assets/Images/Icons/stage.png";
import curtainsIcon from "../../assets/Images/Icons/curtains.png";
import projectorIcon from "../../assets/Images/Icons/projector.png";
import audioIcon from "../../assets/Images/Icons/audio-equipment.png";
import microphoneIcon from "../../assets/Images/Icons/microphone.png";
import hostessIcon from "../../assets/Images/Icons/hostess_or_technician.png";
import capacityIcon from "../../assets/Images/Icons/capacity.png";
// import capacityIcon from '../../assets/Images/Icons/capacity.png';
import lightIcon from "../../assets/Images/Icons/light.png";
// import tickectIcon from '../../assets/Images/Icons/ticket.png';
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadUser, postBookings } from "../../redux/reducers/authSlice";
import {
  AVAILABLE,
  DUMMY_CODE,
  DUMMY_MONEY,
  FULFILLED,
  NO,
  OPTIONAL,
  UNAVAILABLE,
  VENUE_MANAGER,
  YES,
  timeArray,
} from "../../constants/data";
import Spinner from "../IconSpinner/IconSpinner";
import { ToastContainer, toast } from "react-toastify";
import classNames from "classnames";
import IconCollection from "../IconCollection/IconCollection";
import { useEffect } from "react";
import { fetchCurrentUserAllListing } from "../../redux/reducers/listingSlice";
import Select from "react-select";
import LoadingPage from "../../containers/LoadingPage/LoadingPage";

const ShowListingDetails = (props) => {
  const { listingData } = props;
  const { table, id } = useParams();
  const {
    bookingStatus,
    usertype,
    max_credits,
    credits_used,
    id: userId,
  } = useSelector((state) => state.user.user) || "";
  // const calendly_link = useSelector(state => state.listing?.currentListing?.calendly_link);
  const [data, setData] = useState({
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
    message: "",
  });
  const [focusedInput, setFocusedInput] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isPaidSubscription = max_credits > 1;
  const creditLeft = max_credits - credits_used;
  const isBookable = creditLeft === 0;
  const [userListings, setUserlistings] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchUser() {
      setLoading(true);
      dispatch(loadUser());
      const userListing = await dispatch(fetchCurrentUserAllListing());
      if (userListing?.meta?.requestStatus === "fulfilled") {
        setUserlistings(userListing?.payload?.data);
      }
      setLoading(false);
    }
    fetchUser();
  }, [dispatch]);

  const {
    artist_name,
    show_title,
    // poster,
    // additional_media,
    artist_bio,
    genre,
    synopsis,
    agent,
    agency_name,
    agent_email,
    agent_phone_number,
    manager_email,
    manager_phone_number,
    is_music_under_copy_right,
    is_show_under_copy_right,
    show_ipi_codes,
    show_opera_codes,
    stage_dimension_length,
    stage_dimension_width,
    stage_dimension_height,
    set_design,
    projector,
    screen,
    audio,
    microphones,
    describe_microphones,
    technical_requirement_doc,
    sound_engineer,
    light_engineer,
    hostesses,
    artist_location_city,
    payment_method,
    ideal_share_percentage,
    minimum_fee_required,
    minimum_booking_fee,
    ideal_fee,
    ideal_ticket_price,
    // show_start,
    // show_end,
    calendly_link,
    except_days,
    on_tour,
    twitter,
    youtube,
    tiktok,
    facebook,
    instagram,
    official_website,
    currency,
    reviews,
    user_id,
  } = listingData ?? {};

  const isAuthor = userId === user_id;

  const [currencySymbol = "", currencyName = ""] = currency?.split("-") ?? [];
  const priceObject = ideal_fee
    ? { amount: Number(ideal_fee), ideal_ticket_price }
    : {
        amount: Number(minimum_fee_required),
        ideal_share_percentage,
        ideal_ticket_price,
      };
  const [selectedVenue, setSelectedVenue] = useState(null);

  const handleChange = (selectedOption) => {
    setSelectedVenue(selectedOption);
  };
  const isDayBlocked = (day) => {
    const formattedDate = moment(day).format("MM/DD/YYYY");
    return !isBookable ? except_days?.includes(formattedDate) : true;
  };
  const startTime = moment(data.startTime, "HH:mm");
  const endTime = moment(data.endTime, "HH:mm");
  // const isOutsideRange = (day) => {
  //   if (!show_start || !show_end) return false; // Allow all dates if start or end date is not selected
  //   return !moment(day).isBetween(show_start, show_end, "day", "[]"); // Check if the day is within the selected range
  // };

  const onSubmit = async () => {
    const dataObj = {
      start_date: moment(data?.startDate).format("L"),
      end_date: moment(data?.endDate).format("L"),
      start_time: moment(startTime).format("LT"),
      end_time: moment(endTime).format("LT"),
      message: data?.message,
      booking_listing_id: selectedVenue?.value,
    };
    if (isPaidSubscription) {
      Object.assign(dataObj, {
        price: {
          ...priceObject,
          payment_method,
          currency: currencyName,
        },
      });
    } else {
      Object.assign(dataObj, {
        price: {
          amount: Number(minimum_booking_fee),
          currency: currencyName,
        },
      });
    }
    try {
      const res = await dispatch(postBookings({ table, id, data: dataObj }));
      if (res?.payload?.status === 200) {
        toast.success(res?.payload?.data?.message);
        navigate(
          `/inbox/customer/requests/${
            res?.payload?.data?.data?.booking[
              res?.payload?.data?.data?.booking?.length - 1
            ]
          }`
        );
      } else {
        toast.warn(res?.payload?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const readString = (value) => {
    if (value === YES) {
      return AVAILABLE;
    } else if (value === NO) {
      return UNAVAILABLE;
    } else {
      return OPTIONAL;
    }
  };

  const customOption = (props) => {
    const { innerRef, innerProps, data } = props;
    return (
      <div ref={innerRef} {...innerProps} className={css.selectMenu}>
        <img src={data.image} alt={data.name} loading="lazy" />
        <div>
          <div>{data.venue_name}</div>
          <div className={css.genreText}>{data.venue_tag}</div>
        </div>
      </div>
    );
  };
  const options = userListings?.map((listing) => ({
    value: listing?.id,
    venue_name: listing?.venue_name,
    venue_tag: listing?.venue_tag,
    image: listing?.cover_image?.url,
    label: `${listing?.venue_name}, ${listing?.venue_tag}`,
  }));
  const submitDisable =
    usertype !== VENUE_MANAGER ||
    !data?.message ||
    isAuthor ||
    !data.startDate ||
    !data.endDate ||
    !data.startTime ||
    !data.endTime ||
    !currencyName ||
    isBookable ||
    !selectedVenue?.value;

  return (
    <div className={css.listingDetailsWrapper}>
      <div className={css.contentWrapper}>
        <div className={css.leftContents}>
          <p className={css.subTitle}>{artist_name}</p>

          {artist_bio && (
            <>
              <p className={css.artistBio}>{artist_bio}</p>
            </>
          )}

          {show_title && (
            <>
              <h1 className={css.artistTitle}>{show_title}</h1>
            </>
          )}

          {genre && (
            <>
              <p className={css.artistBio}>
                <span className={css.boldText}></span> {genre}
              </p>
            </>
          )}

          {synopsis && (
            <>
              <h2>Synopsis</h2>
              <p className={css.artistBio}>{synopsis}</p>
            </>
          )}

          <h2 className={css.subTitle}>Contacts</h2>
          {agent ? (
            <>
              {agency_name && (
                <p className={css.addressText}>
                  <span className={css.boldText}>Agency Name: </span>
                  {agency_name}
                </p>
              )}
              {agent_email && (
                <p className={css.addressText}>
                  <span className={css.boldText}>Agent Email: </span>
                  {agent_email}
                </p>
              )}
              {agent_phone_number && (
                <p className={css.addressText}>
                  <span className={css.boldText}>Agent Phone Number: </span>
                  {agent_phone_number}
                </p>
              )}
            </>
          ) : (
            <>
              {manager_email && (
                <p className={css.addressText}>
                  <span className={css.boldText}>Manager Email: </span>
                  {manager_email}
                </p>
              )}
              {manager_phone_number && (
                <p className={css.addressText}>
                  <span className={css.boldText}>Manager Phone Number: </span>
                  {manager_phone_number}
                </p>
              )}
            </>
          )}
        </div>
        {loading ? (
          <LoadingPage />
        ) : (
          <div className={css.orderWrapper}>
            <div>
              {
                !isAuthor && <div>
                  {userListings?.length > 0 && usertype === VENUE_MANAGER ? (
                    <div className={css.orderContents}>
                      <h6>Choose Your Listing</h6>
                      <Select
                        className={css.multiSelectBox}
                        options={options}
                        components={{ Option: customOption }}
                        onChange={handleChange}
                        placeholder="Select a venue"
                      />
                    </div>
                  ) : (
                    <h2 style={{ color: "red" }}>
                      No venues found cannot book
                    </h2>
                  )}
                </div>
              }
              <div className={css.orderContents}>
                <h6 className={css.calenderText}>Calender</h6>
                <DateRangePicker
                  startDate={data.startDate}
                  startDateId="start_date"
                  endDate={data.endDate}
                  endDateId="end_date"
                  onDatesChange={(dates) => {
                    setData({ ...data, ...dates });
                  }}
                  focusedInput={focusedInput}
                  onFocusChange={(focusedInput) =>
                    setFocusedInput(focusedInput)
                  }
                  isDayBlocked={isDayBlocked}
                  // isOutsideRange={isOutsideRange}
                  numberOfMonths={1}
                  hideKeyboardShortcutsPanel={true}
                  minimumNights={0}
                />
                {data.startDate && data.startDate && (
                  <div className={css.timeInputs}>
                    <div>
                      {/* <label htmlFor="startTime">Start Time:</label> */}
                      <select
                        name="startTime"
                        id="startTime"
                        onChange={(e) =>
                          setData({ ...data, startTime: e.target.value })
                        }
                      >
                        <option value="">Start time</option>
                        {timeArray.map((time) => (
                          <option key={time.key} value={time.key}>
                            {time.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <IconCollection name="RIGHT_ARROW" />
                    <div>
                      {/* <label>End Time:</label> */}
                      <select
                        name="endTime"
                        id="endTime"
                        onChange={(e) =>
                          setData({ ...data, endTime: e.target.value })
                        }
                      >
                        <option value="">End time</option>
                        {timeArray
                          .filter(
                            (startTime) =>
                              data?.startTime && data?.startTime < startTime.key
                          )
                          .map((time) => (
                            <option key={time.key} value={time.key}>
                              {time.label}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={css.orderContents}>
              <h6>Additional info</h6>
              {/* ONLY FOR PAID USERS */}
              {is_show_under_copy_right && (
                <div>
                  <p className={css.addressText}>
                    <span className={css.boldText}>Show IPI Codes: </span>
                    <span
                      className={
                        isPaidSubscription || isAuthor ? null : css.blur
                      }
                    >
                      {isPaidSubscription || isAuthor
                        ? show_ipi_codes
                        : DUMMY_CODE}
                    </span>
                  </p>
                  <p className={css.addressText}>
                    <span className={css.boldText}>Show Opera Code: </span>
                    <span
                      className={
                        isPaidSubscription || isAuthor ? null : css.blur
                      }
                    >
                      {isPaidSubscription || isAuthor
                        ? show_opera_codes
                        : DUMMY_CODE}
                    </span>
                  </p>
                </div>
              )}
              <p className={css.addressText}>
                <span className={css.boldText}>Music Under Copy Right: </span>
                <span
                  className={isPaidSubscription || isAuthor ? null : css.blur}
                >
                  {isPaidSubscription || isAuthor
                    ? is_music_under_copy_right
                      ? "Yes"
                      : "No"
                    : DUMMY_CODE}
                </span>
              </p>
              <p className={css.addressText}>
                <span className={css.boldText}>Payment Method: </span>
                <span
                  className={isPaidSubscription || isAuthor ? null : css.blur}
                >
                  {isPaidSubscription || isAuthor ? payment_method : DUMMY_CODE}
                </span>
              </p>

              {artist_location_city && (
                <p className={css.addressText}>
                  <span className={css.boldText}>Artist Location (city): </span>
                  {artist_location_city?.formatted_address}
                </p>
              )}
              {payment_method !== "Revenue Sharing" ? (
                <div>
                  <p className={css.addressText}>
                    <span className={css.boldText}>Ideal Fee: </span>
                    <span
                      className={
                        isPaidSubscription || isAuthor ? null : css.blur
                      }
                    >
                      {isPaidSubscription || isAuthor
                        ? `${currencySymbol}${ideal_fee}`
                        : DUMMY_MONEY}
                    </span>
                  </p>
                </div>
              ) : (
                <div>
                  <p className={css.addressText}>
                    <span className={css.boldText}>Minimum Fee Required: </span>
                    <span
                      className={
                        isPaidSubscription || isAuthor ? null : css.blur
                      }
                    >
                      {isPaidSubscription || isAuthor
                        ? `${currencySymbol}${minimum_fee_required}`
                        : DUMMY_MONEY}
                    </span>
                  </p>
                  <p className={css.addressText}>
                    <span className={css.boldText}>
                      Ideal Share Percentage:{" "}
                    </span>
                    <span
                      className={
                        isPaidSubscription || isAuthor ? null : css.blur
                      }
                    >
                      {isPaidSubscription || isAuthor
                        ? `${ideal_share_percentage}%`
                        : DUMMY_MONEY}
                    </span>
                  </p>
                </div>
              )}
              <p className={css.addressText}>
                <span className={css.boldText}>Ideal Ticket Price: </span>
                <span
                  className={isPaidSubscription || isAuthor ? null : css.blur}
                >
                  {isPaidSubscription || isAuthor
                    ? `${currencySymbol}${ideal_ticket_price}`
                    : DUMMY_MONEY}
                </span>
              </p>
            </div>
            <div className={css.addressText}>
              <label htmlFor="message" className={css.reasonLabel}>
                Message:
              </label>
              <div className="">
                <textarea
                  rows={3}
                  id="message"
                  name="message"
                  value={data?.message}
                  onChange={(e) =>
                    setData({ ...data, message: e.target.value })
                  }
                />
              </div>
            </div>

            <div>
              <button
                type="button"
                className={css.bookButton}
                disabled={submitDisable}
                onClick={onSubmit}
              >
                {bookingStatus === FULFILLED ? (
                  <Spinner rootClassName={css.spinner} />
                ) : (
                  "Book"
                )}
              </button>
              <button
                type="button"
                disabled={
                  usertype !== VENUE_MANAGER ||
                  !isPaidSubscription ||
                  !calendly_link
                }
                className={css.calendlyButton}
              >
                <Link to={calendly_link} target="_blank">
                  Calendly
                </Link>
              </button>
              {isAuthor && (
                <p className={css.registeredText}>Own listing cannot book.</p>
              )}
              {!isPaidSubscription && (
                <p className={css.registeredText}>
                  User must be registered and subscribed to access these
                  features
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* availableAccessories */}
      <div className={css.technicalRequirement}>
        <h1 className={css.title}>Technical requirements</h1>
        <div className={css.technicalContents}>
          <div className={css.technicalColumn}>
            <div className={css.technicalContent}>
              <img src={stageImage} alt="stageImage" />
              <div>
                <p>
                  <span className={css.boldText}>Stage Dimension Length: </span>{" "}
                  {stage_dimension_length} meters
                </p>
                <p></p>
              </div>
            </div>
            <div className={css.technicalContent}>
              <img src={stageImage} alt="stageImage" />
              <div>
                <p>
                  <span className={css.boldText}>Stage Dimension Height: </span>{" "}
                  {stage_dimension_height} meters
                </p>
                <p></p>
              </div>
            </div>
            {stage_dimension_width && (
              <div className={css.technicalContent}>
                <img src={stageImage} alt="stageImage" />
                <div>
                  <p>
                    <span className={css.boldText}>
                      Stage Dimension Width:{" "}
                    </span>{" "}
                    {stage_dimension_width} meters
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            <div className={css.technicalContent}>
              <img src={curtainsIcon} alt="curtainsIcon" />
              <div>
                <p>
                  <span className={css.boldText}>Set design: </span>{" "}
                  {set_design?.slice(0, 200)}
                  {set_design?.length > 200 ? "..." : null}
                </p>
                <p></p>
              </div>
            </div>
          </div>

          <div className={css.technicalColumn}>
            {!!projector && (
              <div className={css.technicalContent}>
                <img src={projectorIcon} alt="projectorIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>Projector: </span>{" "}
                    {readString(projector)}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            {!!screen && (
              <div className={css.technicalContent}>
                <img src={curtainsIcon} alt="curtainsIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>Screen: </span>{" "}
                    {readString(screen)}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            {audio && (
              <div className={css.technicalContent}>
                <img src={audioIcon} alt="audioIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>Audio </span>{" "}
                    {readString(audio)}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            {sound_engineer && (
              <div className={css.technicalContent}>
                <img src={audioIcon} alt="audioIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>Sound Engineer: </span>{" "}
                    {sound_engineer}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            {light_engineer && (
              <div className={css.technicalContent}>
                <img src={lightIcon} alt="lightIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>Light Engineer: </span>{" "}
                    {light_engineer}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
          </div>

          <div className={css.technicalColumn}>
            {hostesses && (
              <div className={css.technicalContent}>
                <img src={hostessIcon} alt="hostessIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>Hostesses: </span>{" "}
                    {hostesses}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            {on_tour && (
              <div className={css.technicalContent}>
                <img src={capacityIcon} alt="capacityIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>On Tour: </span>
                    {on_tour ? "Available" : "Not Available"}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            {microphones && (
              <div className={css.technicalContent}>
                <img src={microphoneIcon} alt="microphoneIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>Microphone: </span>{" "}
                    {microphones?.length === 3 ? "10+" : microphones}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
            {describe_microphones && (
              <div className={css.technicalContent}>
                <img src={microphoneIcon} alt="microphoneIcon" />
                <div>
                  <p>
                    <span className={css.boldText}>
                      Microphones Described:{" "}
                    </span>{" "}
                    {describe_microphones}
                  </p>
                  <p></p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {technical_requirement_doc && (
        <div className={classNames(css.technicalColumn, css.technicalImage)}>
          <p className={css.boldText}>Technical Requirement: </p>
          {technical_requirement_doc?.url.includes(".jpg") ? (
            <img
              width={200}
              height={200}
              src={technical_requirement_doc?.url}
              alt={technical_requirement_doc?.key}
            />
          ) : (
            <embed
              src={`${technical_requirement_doc?.url}`}
              loading="lazy"
            ></embed>
          )}
        </div>
      )}

      {(official_website ||
        facebook ||
        twitter ||
        instagram ||
        youtube ||
        tiktok) && (
        <div>
          <h2 className={css.subTitle}>External Links</h2>
          <div className={css.socialContents}>
            {official_website && (
              <div className={css.socialContent}>
                {/* <p className={css.socialText}><span>Official Website - </span></p> */}
                <a
                  className={css.linkText}
                  target="_blank"
                  rel="noreferrer"
                  href={official_website}
                >
                  <IconCollection name="WEB_ICON" />
                </a>
              </div>
            )}
            {facebook && (
              <div className={css.socialContent}>
                {/* <p className={css.socialText}><span>Facebook - </span></p> */}
                <a
                  className={css.linkText}
                  target="_blank"
                  rel="noreferrer"
                  href={facebook}
                >
                  <IconCollection name="FACEBOOK_ICON" />
                </a>
              </div>
            )}
            {twitter && (
              <div className={css.socialContent}>
                {/* <p className={css.socialText}><span>Twitter - </span></p> */}
                <a
                  className={css.linkText}
                  target="_blank"
                  rel="noreferrer"
                  href={twitter}
                >
                  <IconCollection name="TWITTER_ICON" />
                </a>
              </div>
            )}
            {instagram && (
              <div className={css.socialContent}>
                {/* <p className={css.socialText}><span>Instagram - </span></p> */}
                <a
                  className={css.linkText}
                  target="_blank"
                  rel="noreferrer"
                  href={instagram}
                >
                  <IconCollection name="INSTAGRAM_ICON" />
                </a>
              </div>
            )}
            {youtube && (
              <div className={css.socialContent}>
                {/* <p className={css.socialText}><span>Youtube - </span></p> */}
                <a
                  className={css.linkText}
                  target="_blank"
                  rel="noreferrer"
                  href={youtube}
                >
                  <IconCollection name="YOUTUBE_ICON" />
                </a>
              </div>
            )}
            {tiktok && (
              <div className={css.socialContent}>
                {/* <p className={css.socialText}><span>Tiktok - </span></p> */}
                <a
                  className={css.linkText}
                  target="_blank"
                  rel="noreferrer"
                  href={tiktok}
                >
                  <IconCollection name="TIKTOK_ICON" />
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      {reviews && (
        <div>
          <h2 className={css.subTitle}>Reviews</h2>
          <a
            className={css.linkText}
            target="_blank"
            rel="noreferrer"
            href={reviews}
          >
            <IconCollection name="REVIEW_ICON" />
          </a>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default ShowListingDetails;
